import { AppAlert } from '@components/antd';
import { useSupportChat } from '@shared/hooks/use-support-chat';
import { Trans } from 'react-i18next';

export const TwilioErrorBanner = () => {
  const { openSupportChat } = useSupportChat();
  return (
    <AppAlert
      showIcon
      type="error"
      message={
        <p>
          <Trans
            i18nKey="there_was_a_problem_with_your_account_configuration_please_contact_customer_support"
            components={[
              <span key="support-link" className="cursor-pointer text-amber-700" onClick={openSupportChat}></span>,
            ]}
          />
        </p>
      }
    />
  );
};
